// extracted by mini-css-extract-plugin
module.exports = {"dollarSymbol":"_1iWhwEWM","savingsAmountText":"_1VAqaP9_"};